import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ClientService } from '@fitness-force/api';
import { PlanSummary } from '@fitness-force/models';
import { ShortNamePipe } from '@fitness-force/pipes/short-name';
import { TranslateModule } from '@ngx-translate/core';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { PopoverModule } from 'primeng/popover';
import { SkeletonModule } from 'primeng/skeleton';
import { BehaviorSubject, Observable } from 'rxjs';
import { ChangeBilllingNameComponent } from '../change-billling-name/change-billling-name.component';

@Component({
  selector: 'billing-client-info',
  templateUrl: './billing-client-info.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AvatarModule,
    ShortNamePipe,
    SkeletonModule,
    PopoverModule,
    ButtonModule,
    ChangeBilllingNameComponent,
    TranslateModule
  ]
})
export class BillingClientInfoComponent implements OnInit {
  @Input('showSkeleton') showSkeleton$ = new BehaviorSubject<boolean>(true);
  @Input('planSummarydata') planSummary$!: Observable<PlanSummary>;
  @Output() ChangeBillingNameEvent : EventEmitter<{billingName: string}>  = new EventEmitter();
  
  showChangeBillingNameModel$ = new BehaviorSubject<boolean>(false);
  isRemoveBillingName:boolean=false;
  billingName:string="";

  constructor(private clientService:ClientService) { }

  ngOnInit(): void {
  }

  clientStatus(client: any): string {
    if (client && client.client_status)
      return this.clientService.getClientStatusHtml(
        client.client_status.toString()
      );
    else return '';
  }

  removeBillingName() {
    this.billingName="";
    this.ChangeBillingNameEvent.emit({billingName: this.billingName})
  }

  
  closeChangeBillingNameDialogEvent(event:{hidePopup: boolean;billingName: string})
  {
    this.showChangeBillingNameModel$.next(false);
    this.billingName= event.billingName;
    this.ChangeBillingNameEvent.emit({billingName: this.billingName})
  }

}
